<script setup>
import {inject} from "vue";
//import functions
//import components
import {InputText, FloatLabel, Dialog, Listbox, MultiSelect, Checkbox} from "primevue";
import {Icon} from "@iconify/vue";
//import stores
import {useMarketMapStore} from "@/stores/marketMap.js";
//import composables
import {useBreakpoint} from "@/composables/useBreakpoint.js";
import {useLoadingFlags} from "@/composables/useLoadingFlags.js";
import {useToast} from "primevue/usetoast";
import {useConfigData} from "@/composables/useConfigData.js";

//stores
const marketMapStore = useMarketMapStore();

//loading flags
const {
  saving,
  setSaving,
} = useLoadingFlags()

//composables
const {isXL} = useBreakpoint();
const toast = useToast();
const {games} = useConfigData('Boost')

//emits
const emit = defineEmits(['update:filters']);

//props
const props = defineProps({
  /*selectedHotOrder: {
    type: Object,
    required: true
  }*/
});

//injects
const visible = inject('isShowFiltersModal')

//component variables
const stores = [
  {
    value: 'DealHub',
    label: 'DealHub',
  },
  {
    value: 'Incepto',
    label: 'Incepto',
  }
]

//global functions

//component functions

//hooks

//provides
</script>
<template>
  <Dialog v-model:visible="visible"
          :class="['max-w-3xl !border-0 !rounded-md !bg-[#0e1726]', isXL ? '' : 'w-full']"
          :position="isXL ? 'center' : 'bottom'"
          closable dismissable-mask draggable modal
          content-class="flex flex-col gap-4 overflow-hidden h-full w-full max-w-[calc(100vw-20px)] max-h-[calc(100vh-100px)]">
    <template #header>
      <div class="flex flex-row justify-between w-full">
        <div class="text-base py-3">
          Filters
        </div>
        <button @click="marketMapStore.filter = { games: [], stores: [], isActive: false }" class="hover:underline text-xs">Reset Filters</button>
      </div>
    </template>
    <template #closebutton="{closeCallback}">
      <div class="h-full w-[1px] bg-slate-700"></div>
      <button
          type="button"
          class="text-white-dark outline-none hover:text-red-500"
          @click="closeCallback"
      >
        <Icon icon="pajamas:close-xs"/>
      </button>
    </template>
    <div class="flex-1 flex flex-col gap-4 overflow-y-auto pt-4 pb-1 text-xs 2xl:text-sm min-w-80 max-w-full">
      <FloatLabel class="max-w-[320px] custom-multiselect" variant="on">
        <MultiSelect v-model="marketMapStore.filter.games" inputId="game" display="chip"
                     :options="games"
                     optionLabel="game"
                     optionValue="game"
                     filter auto-filter-focus show-clear
                     :maxSelectedLabels="0"
                     class="w-full min-w-28 !bg-transparent h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                     input-class="!text-xs 2xl:!text-sm"
                     overlayClass="custom-select-overlay"/>
        <label for="game" class="!bg-slate-900">Game</label>
      </FloatLabel>
      <FloatLabel class="max-w-[320px] custom-multiselect" variant="on">
        <MultiSelect v-model="marketMapStore.filter.stores" inputId="store" display="chip"
                     :options="stores"
                     optionLabel="label"
                     optionValue="value"
                     show-clear
                     :maxSelectedLabels="0"
                     class="w-full min-w-28 !bg-transparent h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                     input-class="!text-xs 2xl:!text-sm"
                     overlayClass="custom-select-overlay"/>
        <label for="store" class="!bg-slate-900">Store</label>
      </FloatLabel>
      <div class="flex flex-row gap-2 items-center">
        <Checkbox inputId="allOffers" v-model="marketMapStore.filter.allOffers" binary />
        <label for="allOffers">All offers</label>
      </div>
    </div>
    <div class="flex justify-end gap-3 select-none">
      <button @click="visible = false"
              class="btn btn-outline-dark flex items-center justify-center gap-3 disabled:opacity-50 py-1">
        <Icon v-if="saving" icon="eos-icons:bubble-loading" height="24"/>
        Apply
      </button>
    </div>
  </Dialog>
</template>
<style></style>